import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { Flex } from "@redotech/redo-web/flex";
import { Link } from "@redotech/redo-web/link";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const AfterHoursCondition = memo(function AfterHoursCondition() {
  const { t } = useTranslation();
  const team = useRequiredContext(TeamContext);
  const customerWidgetSupportLink = `/stores/${team._id}/settings/customer-widget?tab=support`;

  return (
    <Flex dir="column" gap="sm" w="full">
      <Text fontSize="sm" textColor="secondary">
        {t(
          "This condition will match when a message is received outside of business hours.",
        )}{" "}
        <Link to={customerWidgetSupportLink}>
          {t("Configure business hours")}
        </Link>
      </Text>
    </Flex>
  );
});
